module.exports = __webpack_public_path__ + "img/shengc.942fbfe5.svg";